import { axiosInstance } from "./AxiosDefaults";
import {
  RegistrationDto,
  RegistrationCompanyDto,
} from "../models/Registration";

export const getAllRegistrations = (): Promise<any> => {
  return axiosInstance.get("/registrations", {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateRegistrationComment = async (
  id?: string,
  data?: { note: string }
): Promise<any> => {
  return axiosInstance.put(`${"/registrations"}/comment/${id}`, data, {
    headers: { "Content-Type": "application/json" },
  });
};

export const getAllCompanyRegistrations = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;
  return axiosInstance.get("/registrations-company", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getAllCompanyInformation = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;
  return axiosInstance.get("/company-information", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getParticipantRoomNumber = (roomId: string): Promise<any> => {
  return axiosInstance.get(`${`/registrations`}/roomId/${roomId}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getRegistration = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/registrations`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const reservedRegistration = async (
  id: string,
  roomNumber: any
): Promise<any> => {
  return axiosInstance.put(`${`/registrations/reserved`}/${id}`, roomNumber, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const payRegistration = async (id: string): Promise<any> => {
  return axiosInstance.put(`${`/registrations/pay`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateRegistration = async (
  id?: string,
  registration?: RegistrationDto
): Promise<any> => {
  return axiosInstance.put(`${"/registrations"}/${id}`, registration, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteRegistration = (id: string): Promise<any> => {
  return axiosInstance.delete(`${`/registrations`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getCompanyRegistration = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/registrations-company`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const deletetCompanyRegistration = (id: string): Promise<any> => {
  return axiosInstance.delete(`${`/registrations-company`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createRegistration = (
  registration: RegistrationDto
): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;
  return axiosInstance.post("/registrations", registration, {
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const createCompanyRegistration = (
  registration: RegistrationCompanyDto
): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;
  return axiosInstance.post("/registrations-company", registration, {
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const updateCompanyRegistration = async (
  id?: string,
  registration?: RegistrationCompanyDto
): Promise<any> => {
  return axiosInstance.put(`${"/registrations-company"}/${id}`, registration, {
    headers: { "Content-Type": "application/json" },
  });
};
